import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { ProposeNewTime } = await import('./index');
    return {
        Component: ProposeNewTime,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
